import { db } from '../../config/firebaseConfig'
const state = {
  isLoading: true,
  productList: [],
  categories: []
}

const mutations = {
  'UPDATE_PRODUCT_LIST' (state, productList) {
    if (productList.length) {
      state.productList = productList.filter(product => !product.isDeleted)
    } else {
      state.productList = productList // empty
    }
    state.isLoading = false
  },
  'UPDATE_CATEGORY_LIST' (state, categories) {
    state.categories = categories
  }
}

const actions = {
  listenToProductList: ({ commit, getters }) => {
    if (getters.shopId !== '') {
      return db().ref(`/stores/${getters.shopId}/products`).on('value', (products) => {
        console.log('got products')
        if (products.val() && products.val().length > 0) {
          commit('UPDATE_PRODUCT_LIST', products.val())
        } else {
          commit('UPDATE_PRODUCT_LIST', 0)
        }
      })
    }
  },
  listenToCategories: ({ commit, getters }) => {
    if (getters.shopId !== '') {
      return db().ref(`/stores/${getters.shopId}/categories`).on('value', (categories) => {
        console.log('got categories')
        if (categories.val() && categories.val().length > 0) {
          commit('UPDATE_CATEGORY_LIST', categories.val())
        } else {
          commit('UPDATE_CATEGORY_LIST', [])
        }
      })
    }
  }
}

const getters = {
  products: (state) => {
    return state.productList
  },
  categories: (state, getters) => {
    if (state.categories.length > 0) {
      return state.categories
    } else if (state.productList.length > 0) {
      let categories = []
      getters.products.forEach((product) => {
        if (typeof product.category !== 'undefined' && !product.disabled && !categories.includes(product.category)) {
          categories.push(product.category)
        }
      })
      return categories
    } else {
      console.log(state.productList)
    }
  },
  isProductLoading: (state) => {
    return state.isLoading
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
